var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",attrs:{"height":"50","width":"136.38","alt":"Perkins","src":"https://a.storyblok.com/f/99717/277x150/ed0d36fa22/perkins-logo-tag-1c.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }